"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasDeclineWorkflow = void 0;
const azavista_types_1 = require("@azavista/azavista-types");
const Types_1 = require("./Types");
const CanvasWorkflow_1 = require("./CanvasWorkflow");
const validation_1 = require("./validation/validation");
class CanvasDeclineWorkflow extends CanvasWorkflow_1.CanvasWorkflow {
  constructor() {
    super();
    this.outputPin = [];
    this.inputPin = [Types_1.InputPin.DECLINE_INPUT];
    this.type = Types_1.WorkflowType.DECLINE;
    this.settings = this.getDefaultSettings();
    this.customProcess = {
      decline_initiated_sequence: null,
      decline_finalized_sequence: null
    };
    this.schema = validation_1.DeclineSchema;
  }
  getDefaultSettings() {
    return {
      disable_forms: true,
      form_ids: [],
      email_campaign_id: null,
      thank_you_page_id: null,
      count_as: azavista_types_1.CrmStatus.DECLINED,
      declined_stage_name: '',
      declined_with_reason_stage_name: '',
      register_workflow_id: null,
      next_workflow_ids: {}
    };
  }
  setNextWorkflow(pin, next_workflow_id) {}
  getNextWorkflows() {
    const o = {};
    return o;
  }
  setCustomProcess(s, p) {
    if (s === 'decline_initiated_sequence') {
      this.customProcess.decline_initiated_sequence = p;
    }
    if (s === 'decline_finalized_sequence') {
      this.customProcess.decline_finalized_sequence = p;
    }
  }
  getProperties() {
    return [{
      attribute: 'decline_initiated_sequence',
      datasource: null,
      label: 'INITIATION_SEQUENCE',
      type: 'process',
      mandatory: false,
      value: null
    }, {
      attribute: 'declined_stage_name',
      datasource: null,
      label: 'DECLINED_STAGE_NAME',
      type: 'text',
      mandatory: true,
      value: this.settings.declined_stage_name
    }, {
      attribute: 'disable_forms',
      datasource: null,
      label: 'DISABLE_FORMS',
      type: 'boolean',
      mandatory: false,
      value: this.settings.disable_forms
    }, {
      attribute: 'form_ids',
      datasource: 'Form',
      label: 'FORMS',
      type: 'multiselect',
      mandatory: true,
      value: this.settings.form_ids
    }, {
      attribute: 'thank_you_page_id',
      datasource: 'Page',
      label: 'THANK_YOU_PAGE',
      type: 'select',
      mandatory: false,
      value: this.settings.thank_you_page_id
    }, {
      attribute: 'email_campaign_id',
      datasource: 'Email',
      label: 'DECLINE_EMAIL',
      type: 'select',
      mandatory: false,
      value: this.settings.email_campaign_id
    }, {
      attribute: 'declined_with_reason_stage_name',
      datasource: null,
      label: 'DECLINED_AND_REASON_FROM_COMPLETED_STAGE',
      type: 'text',
      mandatory: false,
      value: this.settings.declined_with_reason_stage_name
    }, {
      attribute: 'register_workflow_id',
      datasource: 'Workflow',
      label: 'CONTINUE_REGISTRATION_AFTER_DECLINE',
      type: 'select',
      mandatory: false,
      value: this.settings.register_workflow_id
    }, {
      attribute: 'decline_finalized_sequence',
      datasource: null,
      label: 'FINALIZATION_SEQUENCE',
      type: 'process',
      mandatory: false,
      value: null
    }];
  }
}
exports.CanvasDeclineWorkflow = CanvasDeclineWorkflow;
